import { createSlice } from "@reduxjs/toolkit";

export const syncTboHotelSlice = createSlice({
    name: "tboSyncCity",
    initialState: {
        tboSyncCites: [],
        loading: false,
        error: null,
    },
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload; 
            if (action.payload) state.error = null;
        },
        setSyncTboCities: (state, action) => {
            state.loading = false;
            state.error = null;
            state.tboSyncCites = Array.isArray(action.payload) ? action.payload : [];
        },
        setError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

// Export actions
export const { setLoading, setSyncTboCities, setError } = syncTboHotelSlice.actions;

// Export reducer
export default syncTboHotelSlice.reducer;
